<template>
  <v-container id="self-signup" class="fill-height" tag="section" justify-center>
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card color="primary" light max-width="100%" width="520" class="px-5 py-3">
          <template v-slot:heading>
            <div class="text-center">
              <v-icon>mdi-account-plus</v-icon>
              {{ $t("signup-title") }}
            </div>
          </template>

          <v-card-text class="text-center">
            <ValidationObserver v-if="!createdCode" ref="obs" v-slot="{ invalid }">
              <v-form>
                <v-row dense>
                  <v-col cols="12" md="6">
                    <ValidationProvider rules="required" v-slot="{ errors, valid }">
                      <v-text-field
                        v-model="first_name"
                        prepend-icon="mdi-account"
                        :label="$t('usreditor-hint-name')"
                        :error-messages="errors"
                        :success="valid"
                        required
                      />
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" md="6">
                    <ValidationProvider rules="required" v-slot="{ errors, valid }">
                      <v-text-field
                        v-model="last_name"
                        prepend-icon="mdi-account"
                        :label="$t('usreditor-hint-surname')"
                        :error-messages="errors"
                        :success="valid"
                        required
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <ValidationProvider rules="required|email" v-slot="{ errors, valid }">
                  <v-text-field
                    v-model="email"
                    prepend-icon="mdi-email"
                    :label="$t('usreditor-hint-email')"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </ValidationProvider>

                <ValidationProvider rules="required" v-slot="{ errors, valid }">
                  <v-select
                    v-model="tipologia"
                    prepend-icon="mdi-format-list-bulleted-type"
                    :label="$t('usreditor-hint-type')"
                    :items="tipologiaOptions"
                    item-text="name"
                    item-value="id"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </ValidationProvider>

                <ValidationProvider rules="required|min:6" v-slot="{ errors, valid }">
                  <v-text-field
                    v-model="password"
                    prepend-icon="mdi-lock-outline"
                    :label="$t('usreditor-hint-password')"
                    :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="passwordVisible = !passwordVisible"
                    :type="passwordVisible ? 'text' : 'password'"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </ValidationProvider>

                <ValidationProvider rules="required|min:6" v-slot="{ errors, valid }">
                  <v-text-field
                    v-model="confirmPassword"
                    prepend-icon="mdi-lock-check"
                    :label="$t('usreditor-hint-repeatpassword')"
                    :append-icon="confirmVisible ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="confirmVisible = !confirmVisible"
                    :type="confirmVisible ? 'text' : 'password'"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </ValidationProvider>

                <v-btn
                  color="primary"
                  class="mt-3"
                  :disabled="invalid || loading"
                  @click="signup"
                >
                  {{ $t("signup-button") }}
                </v-btn>
              </v-form>
            </ValidationObserver>

            <v-progress-circular
              v-if="loading && !createdCode"
              :indeterminate="true"
              :rotate="0"
              :size="30"
              :width="4"
              color="light-blue"
              class="mt-4"
            />

            <v-alert v-if="error && !createdCode" type="error" dense dark dismissible class="mt-4">
              {{ error }}
            </v-alert>

            <v-alert v-if="createdCode" type="success" dense class="mt-4" border="left">
              {{ $t("signup-created-code") }} <strong>{{ createdCode }}</strong>
            </v-alert>

            <p style="margin-top: 20px;">
              <router-link to="/login">{{ $t("signup-back-login") }}</router-link>
            </p>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
import userManager from "../apis/users";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },

  data() {
    return {
      first_name: "",
      last_name: "",
      email: "",
      tipologia: "LIVE",
      tipologiaOptions: [
        { id: "LIVE", name: "Live" },
        { id: "VIDEOCALL", name: "Videocall" }
      ],
      password: "",
      confirmPassword: "",
      passwordVisible: false,
      confirmVisible: false,
      loading: false,
      error: "",
      createdCode: ""
    };
  },

  mounted() {
    const routeType =
      this.$route && this.$route.query && this.$route.query.tipologia
        ? String(this.$route.query.tipologia).toUpperCase()
        : null;
    if (routeType && this.tipologiaOptions.some(x => x.id === routeType)) {
      this.tipologia = routeType;
    }
  },

  methods: {
    signup() {
      this.error = "";

      if (this.password !== this.confirmPassword) {
        this.error = this.$t("signup-password-mismatch");
        return;
      }

      this.loading = true;
      userManager
        .selfSignup({
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          tipologia: this.tipologia,
          password: this.password
        })
        .then(data => {
          this.createdCode = data.ope_code;
          this.password = "";
          this.confirmPassword = "";
          this.first_name = "";
          this.last_name = "";
          this.email = "";
          this.loading = false;
        })
        .catch(err => {
          this.error =
            (err && err.response && err.response.data && err.response.data.responseError) ||
            this.$t("signup-generic-error");
          this.loading = false;
        });
    }
  }
};
</script>
